import React from "react";
import { Link, useParams } from "react-router-dom";
import { Card } from "flowbite-react";

const RestauranteDashboard = () => {
  const { cliente_id } = useParams(); // Captura el cliente_id de los parámetros de la URL

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center py-6">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">
        Panel de Administración - Restaurante
      </h1>
      <div className="w-full max-w-4xl">
        <Card>
          <nav>
            <ul className="space-y-4">
              <li>
                <Link
                  to={`/clover-categories?cliente_id=${cliente_id}`}
                  className="block px-4 py-2 text-center text-white bg-blue-600 rounded-lg hover:bg-blue-700"
                >
                  Gestión de Categorías
                </Link>
              </li>
              <li>
                <Link
                  to={`/clover-products?cliente_id=${cliente_id}`}
                  className="block px-4 py-2 text-center text-white bg-green-600 rounded-lg hover:bg-green-700"
                >
                  Gestión de Productos
                </Link>
              </li>
              <li>
                <Link
                  to={`/settings?cliente_id=${cliente_id}`}
                  className="block px-4 py-2 text-center text-white bg-purple-600 rounded-lg hover:bg-purple-700"
                >
                  Configuraciones
                </Link>
              </li>
              <li>
                <Link
                  to={`/popups?cliente_id=${cliente_id}`}
                  className="block px-4 py-2 text-center text-white bg-yellow-600 rounded-lg hover:bg-yellow-700"
                > 
                  Gestión de Popups
                </Link>
              </li>

             <li>
             <Link
               to={`/crear-oferta?cliente_id=${cliente_id}`}
               className="block px-4 py-2 text-center text-white bg-red-600 rounded-lg hover:bg-red-700 transition"
              >
               Crear Oferta
               </Link>
              </li>

            </ul>
          </nav>
        </Card>
      </div>
    </div>
  );
};

export default RestauranteDashboard;
